import { Box, Text } from '@chakra-ui/react';
import { IconAlertTriangle } from '@tabler/icons';
import { ButtonComponent } from 'components/buttons/ButtonComponent';
import GenericModal from 'components/modal/genericModal/GenericModal';

import { planningTableMessages } from '../variables/planningTableMessages';

interface LeavePageModalProps {
	isOpen: boolean;
	onConfirm: () => void;
	onCancel: () => void;
	description: string;
}

export const LeavePageModal = ({
	isOpen,
	onConfirm,
	onCancel,
	description,
}: LeavePageModalProps) => {
	return (
		<GenericModal
			zIndex={2000}
			isOpen={isOpen}
			onClose={onCancel}
			title={planningTableMessages.MSG_LEAVE_TITLE}
			titleIcon={IconAlertTriangle}
			titleIconBoxSize={12}
			maxWidth='80vh'
			onSave={onConfirm}
			saveButtonText='Sim, descartar alterações'
			cancelButtonText='Cancelar'
			customSaveButton={
				<ButtonComponent
					title='Sim, descartar alterações'
					onClick={onConfirm}
					type='secondary'
				/>
			}
		>
			<Box mt={-6}>
				<Text
					color='gray.500'
					fontSize='sm'
					fontWeight={200}
				>
					{description}
				</Text>
			</Box>
		</GenericModal>
	);
};
